// @ts-ignore
import AuthActions from 'auth/AuthActions';
import LinkConstants from 'constants/LinkConstants';

export function getGooglePlayShortLink(
  authToken: string | undefined = AuthActions.getAutologinTokenFromCookies()
): string {
  let url: string = LinkConstants.APP_DOWNLOAD;

  if (authToken) {
    url += LinkConstants.GOOGLE_PLAY_SHORT_LINK_REFERRER_AUTOLOGIN_PARAM + authToken;
  }

  return url;
}

export default function getGooglePlayLink(
  authToken: string | undefined = AuthActions.getAutologinTokenFromCookies()
): string {
  let url: string = LinkConstants.GOOGLE_PLAY;

  if (authToken) {
    // Google Play Store forces the url to be terrible and follow a format
    // where only half the query string is encoded. Since everything except
    // for the authToken is constant for this url, we append the auth
    // token at the end via. string concatenation.
    url += LinkConstants.GOOGLE_PLAY_AUTOLOGIN_PARAM + authToken;
  }

  return url;
}
